module.exports = __webpack_public_path__ + "static/media/camper_in_spanje.921fa52a.jpg";